export default __webpack_public_path__ + "static/media/idan-roll.34574be7.png";